module.exports = __webpack_public_path__ + "img/fix_icon_logo_2.e16b9b41.svg";